import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import axios from 'axios';
import toast from 'react-hot-toast';
import { getApiErrorMessage } from '@/utils/apiError';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Only toast for background refetch failures (data was previously loaded)
      if (query.state.data !== undefined) {
        toast.error(getApiErrorMessage(error, 'Background data refresh failed'));
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Skip if the mutation already has its own onError callback
      if (mutation.options.onError) return;
      // 401s are handled by the axios interceptor
      if (axios.isAxiosError(error) && error.response?.status === 401) return;

      toast.error(getApiErrorMessage(error, 'An unexpected error occurred'));
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx) — they won't magically succeed
        if (axios.isAxiosError(error) && error.response?.status && error.response.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 10_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});
